import Reports from "../../../container/reports";
import Summary from "../../../container/reports/summary"
import InstallStats from "../../../container/reports/installStats"
import SummarizedInventoryReport from "../../../container/reports/summarizedInventoryReport"
import BomByBlockContainer from "../../../container/reports/BomByBlock";
import ScopeAllocatedPerLaydownContainer from "../../../container/reports/ScopeAllocatedPerLaydown";

const setupRoute = [
  {
    path: "reports",
    element: <Reports />,
  },
  {
    path: "reports/summary",
    element: <Summary />
  },
  {
    path: "reports/install-stats",
    element: <InstallStats />
  },
  {
    path:"reports/BomByBlock",
    element:<BomByBlockContainer />
  },
  {
    path: "reports/summarized-inventory-report",
    element: <SummarizedInventoryReport/>
  },
  {
    path:"reports/scope-allocated-per-laydown",
    element:<ScopeAllocatedPerLaydownContainer/>
  }
];

export default setupRoute;
